import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as config from "../../../../../constants/config";
import * as componentTypes from "../../../../../constants/componentTypes";
import * as serverActions from "../../../../../actions/serverActions";
import * as navigationActions from "../../../../../actions/navigationActions";

import Server from "../../../../../models/utils/Server";

import * as validationHelper from "../../../../../helpers/validationHelper";

class AddServerModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            serverName: "",
            serverHost: "",
            serverPort: config.SERVER_PORT + "",
            serverNote: ""
        };
    }

    handleServerHostChange = (event) => {
        this.setState({serverHost: event.target.value});
    };

    handleAddButtonClick = () => {
        let newServer = new Server(this.state.serverHost, Number(this.state.serverPort), null, this.state.serverName);
        newServer.note = this.state.serverNote;
        this.props.dispatchAddServerAction(newServer);
        this.props.dispatchCloseServerModalAction();
    };

    handleServerNoteChange = (event) => {
        this.setState({
            serverNote: event.target.value
        });
    };

    handleServerNameChange = (event) => {
        this.setState({
            serverName: event.target.value
        });
    };

    handleServerPortChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({serverPort: event.target.value});
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseServerModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    render() {
        return (
            <div id="modal" className="default-modal settings-modal ig-small-modal server-modal">
                <div className="modal-content">
                    <h4 className="text-left ">
                        <Translate value="clientServerSettings.addNewServer" />
                    </h4>
                    <div className="row col-xs-12 select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="clientServerSettings.serverName" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverName}
                                onChange={this.handleServerNameChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="row col-xs-12 select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="general.ip" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverHost}
                                onChange={this.handleServerHostChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="row col-xs-12 select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="clientServerSettings.port" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverPort}
                                onChange={this.handleServerPortChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="row col-xs-12 select-machine-title">
                        <div className="col-xs-4 text-right">
                            <Translate value="general.note" />:
                        </div>
                        <div className="col-xs-8">
                            <input
                                className="input-dark"
                                type="text"
                                value={this.state.serverNote}
                                onChange={this.handleServerNoteChange}
                                onFocus={this.handleInputFocus}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-12 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleAddButtonClick}>
                                <Translate value="general.add" />
                            </button>
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseServerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_ADD_SERVER_MODAL));
        },
        dispatchAddServerAction: (server) => {
            dispatch(serverActions.addServer(server));
        }
    };
};

export default AddServerModal = connect(mapStoreToProps, mapDispatchToProps)(AddServerModal);
